import React, { Component } from 'react';
import moment from 'moment';
import { StyledWidgetWrap } from './style';

/** Components */
import TrafficStart from './Start';
import Error from '../Error';
import TrafficConfigAdress from './ConfigAdress';
import TrafficInfo from './TrafficInfo';
import TrafficEdit from './Edit';
import {
  StyledWidgetMini,
  StyledTitle,
  StyledWrapTitle,
  StyleIcon
} from '../../../../core/WidgetMini/style';
import Loading from '../../../../core/Loading';

/** Icons */
import { Config, CloseMini } from '../../../../../../assets/images';

/** API */
import {
  getTraffic,
  setTrafficConfig,
  getTrafficConfig,
  removeTrafficConfig
} from '../../../../../utils/apiMiniWidget';

class Traffic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 0,
      duration: 0,
      trafficStatus: 'HEAVY',
      direction: 'HOME',
      config: false,
      configId: null,
      address: '',
      lastUpdate: 0
    };
  }

  componentDidMount() {
    const user = { ...this.props.userId };

    if (user.userId) {
      getTrafficConfig(user.userId)
        .then(({ id, userAddress }) => {
          const statusUpdated = userAddress ? 2 : 3;

          this.setState({
            configId: id,
            address: userAddress,
            status: statusUpdated
          });
        })
        .finally(() => this.getInfo(false, user.userId));
    }
  }

  onGetInfoSuccess = ({ duration, trafficStatus, direction }) => {
    this.setState({
      duration,
      trafficStatus,
      direction,
      lastUpdate: moment(new Date()).format('HH:mm'),
      status: 3
    });
  };

  onGetInfoError = ({ code }) => {
    // 404 when the user has no config
    if (code === 404) {
      this.setState({
        status: 1
      });
    } else {
      this.setState({
        status: -1
      });
    }
  };

  onEditGetInfoError = () => {
    this.setState({
      status: -1
    });
  };

  onHandleConfig = () => {
    const { address, status } = this.state;
    let statusUpdated = null;
    let configUpdated = true;

    if (address) {
      switch (status) {
        case 2:
        case 3:
          statusUpdated = 4;
          configUpdated = true;
          break;
        case 4:
        case -1:
          statusUpdated = 3;
          configUpdated = false;
          break;
        case 1:
        default:
          statusUpdated = 2;
          configUpdated = true;
          break;
      }
    } else if (status === 1) {
      statusUpdated = 2;
      configUpdated = true;
    } else {
      statusUpdated = 1;
      configUpdated = false;
    }

    this.setState({
      config: configUpdated,
      status: statusUpdated
    });
  };

  onSaveAddress = newAddress => {
    const { configId } = this.state;
    // If configId === null is because the user has no config yet
    if (configId === null) {
      setTrafficConfig('POST', newAddress)
        .then(({ id, userAddress, userId }) => {
          this.setState({
            configId: id,
            address: userAddress,
            config: false
          });
          this.getInfo(false, userId);
        })
        .catch(this.onEditGetInfoError);
    } else {
      setTrafficConfig('PUT', newAddress, configId)
        .then(({ userAddress, userId }) => {
          this.setState({
            address: userAddress,
            config: false
          });
          this.getInfo(false, userId);
        })
        .catch(this.onEditGetInfoError);
    }
    // Show loading screen
    this.setState({
      status: 0
    });
  };

  onHandleEdit = () => {
    this.setState({
      status: 2
    });
  };

  onHandleRemove = () => {
    // Show loading screen
    this.setState({
      status: 0
    });

    removeTrafficConfig()
      .then(() =>
        this.setState({
          status: 1,
          address: '',
          config: false,
          configId: null
        })
      )
      .catch(this.onEditGetInfoError);
  };

  getInfo = (initial, userId) => {
    // Set error callback depending on initial param
    const errorCallback = initial ? this.onGetInfoError : null;
    // Set loading screen
    this.setState({
      status: 0
    });
    // Get coords
    navigator.geolocation.getCurrentPosition(
      // onSuccess
      ({ coords }) => {
        const { latitude, longitude } = coords;
        // Get traffic info
        getTraffic(latitude, longitude, userId)
          .then(this.onGetInfoSuccess)
          .catch(errorCallback);
      },
      // onError because the user doesn't allow to know the coords
      () =>
        getTraffic(null, null, userId)
          .then(this.onGetInfoSuccess)
          .catch(errorCallback),
      {
        enableHighAccuracy: true,
        timeout: 8000,
        maximumAge: 0
      }
    );
  };

  renderCurrentStatus = () => {
    const {
      status,
      duration,
      trafficStatus,
      direction,
      lastUpdate,
      address
    } = this.state;

    switch (status) {
      case -1:
        return <Error />;
      case 0:
        return <Loading />;
      case 1:
        return <TrafficStart onClick={this.onHandleConfig} />;
      case 2:
        return (
          <TrafficConfigAdress address={address} onSave={this.onSaveAddress} />
        );
      case 3:
        return (
          <TrafficInfo
            duration={duration}
            trafficStatus={trafficStatus}
            toHome={direction === 'HOME'}
            getTraffic={this.getInfo}
            lastUpdate={lastUpdate}
          />
        );
      case 4:
        return (
          <TrafficEdit
            address={address}
            onClickEdit={this.onHandleEdit}
            onClickRemove={this.onHandleRemove}
          />
        );
      default:
        return null;
    }
  };

  render() {
    const { config } = this.state;
    const { className } = this.props;
    return (
      <StyledWidgetMini type="traffic" className={className}>
        <StyledWrapTitle className="Traffic-header">
          <StyledTitle> Tráfico </StyledTitle>{' '}
          <StyleIcon
            svg={config ? CloseMini : Config}
            size="s"
            color="dark"
            hover
            onClick={this.onHandleConfig}
          />{' '}
        </StyledWrapTitle>{' '}
        <StyledWidgetWrap> {this.renderCurrentStatus()} </StyledWidgetWrap>{' '}
      </StyledWidgetMini>
    );
  }
}

export default Traffic;
